import styles from './listView.module.scss';
import { LuRefreshCcw } from "react-icons/lu";


export const CategorySelector = ({data, selectedCategory, setSelectedCategory, loading, requestReload}) => {
    return <div className={`${styles.catSelector} ${loading ? styles.loading : ''}`}>
        {data && data.options && Array.isArray(data.options) ? data.options.map((option) => {
            return <div key={option.label} className={`${selectedCategory?.label === option.label ? styles.selected : ''} ${option.warning ? styles.warning : ''}`} onClick={()=>{
                if(loading) return;
                setSelectedCategory(option);
            }}>{option.label}</div>
        }) : null}
        {data.refreshButton ? <div className={styles.refreshButton} ><LuRefreshCcw onClick={()=>{requestReload()}} /></div> : null}
    </div>
}